import kinioLogo from '../assets/brand/kinio-logo.png';

export function BrandLogo({ size = 32 }: { size?: number }) {
  return (
    <span className="brand-logo" style={{ width: size, height: size }} aria-label="Kinio">
      <img src={kinioLogo} alt="" />
    </span>
  );
}
